export enum Status {
  SUCCESS = "success",
  ERROR = "error",
  PENDING = "pending",
  LOADING = "loading",
}

export enum FlagColor {
  RED = "red",
  YELLOW = "yellow",
  GREEN = "green",
  WHITE = "white",
}

export enum FlagStatus {
  DEFAULT = "Default",
  BLOCKED = "Blocked",
  RESOLVED = "Resolved",
  IN_PROGRESS = "In Progress",
}

export enum BadgeStatus {
  IN_PROGRESS = "In progress",
  COMPLETE = "Complete",
  PLANNED = "Planned",
  STUCK = "Stuck",
  WARNING = "Warning",
}

export enum Priority {
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low",
}

export enum MilestoneKey {
  CI = "CI",
  M1 = "M1",
  M2 = "M2",
  M3 = "M3",
  M4 = "M4",
}
